import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { Chats } from '#modules/chat/components/Chats';
import { optionalSearchString } from '#utils/searchParams';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/dashboard/chats/')({
  validateSearch: zodValidator(
    z.object({
      // Все четыре приходят из внешних ссылок, а роутер разбирает значение по виду: ник из одних
      // цифр или числовой идентификатор приехали бы числом и уронили экран целиком.
      peerUserId: optionalSearchString(),
      peerDisplayName: optionalSearchString(),
      peerAvatar: optionalSearchString(),
      prefillMessage: optionalSearchString(),
    })
  ),
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  const search = Route.useSearch();

  return (
    <Chats
      pendingPeer={
        search.peerUserId
          ? {
              id: search.peerUserId,
              displayName: search.peerDisplayName ?? null,
              avatar: search.peerAvatar ?? null,
            }
          : undefined
      }
      prefillMessage={search.prefillMessage}
    />
  );
}
